// frontend/src/services/superAdminApi.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const superAdminApi = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token staff
superAdminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============ AIRPORTS ============
export const getAirports = (page = 1, limit = 20, search = '') =>
  superAdminApi.get('/admin/airports/', { params: { page, limit, search } });

export const getAirport = (id) =>
  superAdminApi.get(`/admin/airports/${id}`);

export const createAirport = (data) =>
  superAdminApi.post('/admin/airports/', data);

export const updateAirport = (id, data) =>
  superAdminApi.put(`/admin/airports/${id}`, data);

export const deleteAirport = (id) =>
  superAdminApi.delete(`/admin/airports/${id}`);

export const resetAirportAdminPassword = (id) =>
  superAdminApi.post(`/admin/airports/${id}/reset-password`);

// ============ AIRPORT LICENSES & AGENTS ============
export const getAirportLicense = (airportId) =>
  superAdminApi.get(`/admin/airports/${airportId}/license`);

export const getAirportAgents = (airportId) =>
  superAdminApi.get(`/admin/airports/${airportId}/agents`);

// Tous les agents tous aéroports confondus (pour les selects Hardware)
export const getAllAgents = () =>
  superAdminApi.get('/admin/airports/agents/all');

export const updateAirportAgentsLimit = (airportId, data) =>
  superAdminApi.put(`/admin/airports/${airportId}/license/agents`, data);

export const updateAirportAgent = (airportId, agentId, data) =>
  superAdminApi.put(`/admin/airports/${airportId}/agents/${agentId}`, data);

export const removeAirportAgent = (airportId, agentId) =>
  superAdminApi.delete(`/admin/airports/${airportId}/agents/${agentId}`);

export const resetAirportLicenseKey = (airportId) =>
  superAdminApi.post(`/admin/airports/${airportId}/license/reset`);

export const registerAgent = (licenseKey, agentData) =>
  superAdminApi.post('/video/agents/register', {
    license_key: licenseKey,
    api_key: `agent_${Date.now()}_${Math.random().toString(36).substr(2, 8)}`,
    hardware_id: agentData.hardware_id || `HW_${Date.now()}`,
    hostname: agentData.hostname || `HOST_${Date.now()}`,
    version: '1.0.0',
    name: agentData.name,
  });

// ============ PACKAGES ============
export const getPackages = () =>
  superAdminApi.get('/admin/airports/packages');

export const getAirportPackages = (airportId) =>
  superAdminApi.get(`/admin/airports/${airportId}/packages`);

export const updateAirportPackages = (airportId, packageIds) =>
  superAdminApi.put(`/admin/airports/${airportId}/packages`, { package_ids: packageIds });

// ============ PACKAGES CRUD ============
export const createPackage = (data) =>
  superAdminApi.post('/admin/packages', data);

export const updatePackage = (packageId, data) =>
  superAdminApi.put(`/admin/packages/${packageId}`, data);

export const deletePackage = (packageId) =>
  superAdminApi.delete(`/admin/packages/${packageId}`);